export const getAssets = state =>
    state.assets.data.map(id => state.db.assets[id]);
export const getLoading = state => state.assets.loading;
export const getLoadingMore = state => state.assets.loadingMore;
export const getError = state => state.assets.error;
export const getCanLoadMore = state => state.assets.canLoadMore;

export const getApplications = state => state.db.applications;
export const getBucketId = state => state.assets.bucketId;
export const getBucketName = state => state.assets;
export const getApplication = state => state.assets.application;
export const getApplicationAsset = state => {
    if (!state.assets.application) {
        return undefined;
    }

    return state.db.applications[state.assets.application].asset;
};
export const getOffset = state => state.assets.data.length;
export const getOrder = state => state.assets.order;
export const getOrderDirection = state => state.assets.orderDirection;



// WEBPACK FOOTER //
// ./src/selectors/assetSelectors.js